import { useMemo } from "react";

export const useFormattedAmount = () => {
  return useMemo(() => {
    return {
      format2Decimals: (amount: number) => {
        return amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      },
      formatMoney: (amount: number, currency = 'USD') => {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency,
          minimumFractionDigits: 2
        }).format(amount);
      },
      formatBalances: (amount: number) => {
        return amount.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      },
      formatPercentage: (value: number) => {
        return `${(value * 100).toFixed(2)}%`;
      }
    };
  }, []);
};
